(function () {
  if (shouldDisableCrossDocumentViewTransitions()) {
    disableCrossDocumentViewTransitions();
  }
  const viewTransitionRenderBlocker = document.getElementById(
    'view-transition-render-blocker',
  );
  if (
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    isLowPowerDevice()
  ) {
    viewTransitionRenderBlocker?.remove();
  } else {
    const RENDER_BLOCKER_TIMEOUT_MS = Math.max(0, 1800 - performance.now());
    setTimeout(() => {
      viewTransitionRenderBlocker?.remove();
    }, RENDER_BLOCKER_TIMEOUT_MS);
  }
  const idleCallback =
    typeof requestIdleCallback === 'function'
      ? requestIdleCallback
      : setTimeout;
  const safeStorage = (op) => {
    try {
      return op();
    } catch (error) {
      console.warn('[view-transitions] sessionStorage access failed:', error);
      return null;
    }
  };
  window.addEventListener('pageswap', async (event) => {
    const { viewTransition: viewTransition } = event;
    if (shouldSkipViewTransition(viewTransition)) {
      viewTransition?.skipTransition();
      return;
    }
    ['pointerdown', 'keydown'].forEach((eventName) => {
      document.addEventListener(
        eventName,
        () => {
          viewTransition.skipTransition();
        },
        { once: true },
      );
    });
    document
      .querySelectorAll(
        '[data-view-transition-type]:not([data-view-transition-triggered])',
      )
      .forEach((element) => {
        element.removeAttribute('data-view-transition-type');
      });
    const transitionTriggered = document.querySelector(
      '[data-view-transition-triggered]',
    );
    const transitionType = transitionTriggered?.getAttribute(
      'data-view-transition-type',
    );
    if (transitionType) {
      viewTransition.types.clear();
      viewTransition.types.add(transitionType);
      safeStorage(() =>
        sessionStorage.setItem('custom-transition-type', transitionType),
      );
    } else {
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');
      safeStorage(() => sessionStorage.removeItem('custom-transition-type'));
    }
  });
  window.addEventListener('pagereveal', async (event) => {
    const { viewTransition: viewTransition } = event;
    if (shouldSkipViewTransition(viewTransition)) {
      viewTransition?.skipTransition();
      return;
    }
    const customTransitionType = safeStorage(() =>
      sessionStorage.getItem('custom-transition-type'),
    );
    if (customTransitionType) {
      viewTransition.types.clear();
      viewTransition.types.add(customTransitionType);
      try {
        await viewTransition.finished;
      } catch (error) {
        console.error(
          '[view-transitions] viewTransition.finished rejected:',
          error,
        );
      }
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');
      idleCallback(() => {
        safeStorage(() => sessionStorage.removeItem('custom-transition-type'));
        document
          .querySelectorAll('[data-view-transition-type]')
          .forEach((element) => {
            element.removeAttribute('data-view-transition-type');
          });
      });
    } else {
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');
    }
  });
  function shouldSkipViewTransition(viewTransition) {
    return (
      !(viewTransition instanceof ViewTransition) ||
      isLowPowerDevice() ||
      prefersReducedMotion() ||
      shouldDisableCrossDocumentViewTransitions()
    );
  }
  function shouldDisableCrossDocumentViewTransitions(
    userAgent = navigator.userAgent,
  ) {
    const ua = userAgent || '';
    const androidWebView = /\bAndroid\b/i.test(ua) && /;\s?wv\)/i.test(ua);
    const knownInAppBrowser =
      /\b(FBAN|FBAV|FB_IAB|FBIOS|Instagram|musical_ly|Bytedance|BytedanceWebview|trill|TikTok)(?:\b|_)/i.test(
        ua,
      );
    return androidWebView || knownInAppBrowser;
  }
  function disableCrossDocumentViewTransitions() {
    const style = document.createElement('style');
    style.textContent = '@view-transition { navigation: none; }';
    (document.head || document.documentElement).appendChild(style);
    document.getElementById('view-transition-render-blocker')?.remove();
  }
  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  function isLowPowerDevice() {
    return (
      Number(navigator.hardwareConcurrency) <= 2 ||
      Number(navigator.deviceMemory) <= 2
    );
  }
})();
